<template>
  <div class="mobile-sub-menu">
    <ul class="sub-menu">
      <li class="menu-item" v-for="(item, key) of subMenu" :key="'sub-menu-' + key">
        <router-link
          :to="{ name: item.routerName}"
          v-if="!item.logOut && item.routerName"
        >
          <div class="menu-link">
            <div v-if="hasIcon" class="menu-icon" @click="onClose">
              <img :src="item.icon" :alt="item.title"/>
              <div class="menu-icon_title">{{ item.title }}</div>
            </div>
            <badge v-if="key === 1 && isShowNewsIcon" title="NEW!" class="danger"/>
          </div>
        </router-link>
        <div v-if="!item.routerName && !item.logOut" class="menu-link" @click="openModalNoti">
          <div v-if="hasIcon" class="menu-icon">
            <img :src="item.icon" :alt="item.title"/>
            <div class="menu-icon_title">{{ item.title }}</div>
          </div>
          <badge :title="totalUnread" class="danger" v-if="totalUnread"/>
        </div>
        <div v-if="item.logOut" class="menu-icon menu-link"
             @click="()=>{ confirmLogout() }">
          <img :src="item.icon" :alt="item.title"/>
          <div class="menu-icon_title">{{ item.title }}</div>
        </div>
      </li>
    </ul>
    <CusModal v-if="openModal" :title="'オークション通知'">
      <div class="noti-tabs">
        <div class="tabs" :class="tabName===NOTI_TABS.TAB_ALL ? 'active' : ''"
             @click="changeTab(NOTI_TABS.TAB_ALL)">すべて
        </div>
        <div class="tabs" :class="tabName===NOTI_TABS.TAB_UNREAD ? 'active' : ''"
             @click="changeTab(NOTI_TABS.TAB_UNREAD)">未読
        </div>
      </div>
      <div class="content-noti" @scroll="handleLoadMore">
        <template v-if="tabName === NOTI_TABS.TAB_ALL">
          <div
            v-for="item in allNotifications"
            :key="item.id"
            :class="item.is_delete && 'wrapper-remove-content' || ''"
          >
            <div class="content-noti__wrapper" :class="!item.read_flag && 'readed'">
              <div class="content_detail" :class="item.is_delete && 'remove-content-detail'">
                <div class="img mr-2" v-if="!item.is_delete">
                  <img src="@/assets/images/building-solid.svg"/>
                </div>

                <div class="r-notification" :class="item.is_delete && 'd-flex w-100'">
                  <div
                    class="d-flex"
                    :class="item.is_delete && 'w-100'"
                    @click="!item.is_delete && item.redirect_url ? directPage(item) : null"
                  >
                    <div class="l-detail">
                      <div class="l-detail-header font-weight-bold" v-if="!item.is_delete">
                        {{ item.title }}
                      </div>
                      <div class="text-xs l-detail__info">
                        {{ !item.is_delete ? item.content : '通知を削除しました。' }}
                      </div>
                    </div>
                    <div class="r-detail text-xs" v-if="!item.is_delete">
                      {{ formatDate(item.received_date) }}
                    </div>
                  </div>
                  <img
                    class="undo-notification"
                    src="@/assets/images/undo.svg"
                    v-if="item.is_delete"
                    @click="undoNotification(item, NOTI_TABS.TAB_ALL)"
                  />
                </div>
                <div class="action pt-3" @click="removeNotification(item, NOTI_TABS.TAB_ALL)"
                     v-if="!item.is_delete">
                  <img src="@/assets/images/delete.svg"/>
                </div>
              </div>
            </div>
          </div>
          <template v-if="isLoadingAll">
            <AppLoading/>
          </template>
          <div class="text-center pt-3" v-if="!allNotifications.length && !isLoadingAll">
            新しい通知はありません
          </div>
        </template>
        <template v-if="tabName === NOTI_TABS.TAB_UNREAD">
          <div
            v-for="item in unreadNotifications"
            :key="item.id"
            :class="item.is_delete && 'wrapper-remove-content' || ''"
          >
            <div class="content-noti__wrapper" :class="!item.read_flag && 'readed'" >
              <div class="content_detail" :class="item.is_delete && 'remove-content-detail'">
                <div class="img mr-2" v-if="!item.is_delete">
                  <img src="@/assets/images/building-solid.svg"/>
                </div>

                <div class="r-notification" :class="item.is_delete && 'd-flex w-100'">
                  <div
                    class="d-flex"
                    :class="item.is_delete && 'w-100'"
                    @click="!item.is_delete && item.redirect_url ? directPage(item) : null"
                  >
                    <div class="l-detail">
                      <div class="l-detail-header font-weight-bold" v-if="!item.is_delete">
                        {{ item.title }}
                      </div>
                      <div class="text-xs l-detail__info">
                        {{ !item.is_delete ? item.content : '通知を削除しました。' }}
                      </div>
                    </div>
                    <div class="r-detail text-xs" v-if="!item.is_delete">
                      {{ formatDate(item.received_date) }}
                    </div>
                  </div>
                  <img
                    class="undo-notification"
                    src="@/assets/images/undo.svg"
                    v-if="item.is_delete"
                    @click="undoNotification(item, NOTI_TABS.TAB_ALL)"
                  />
                </div>
                <div class="action pt-3" @click="removeNotification(item, NOTI_TABS.TAB_ALL)"
                     v-if="!item.is_delete">
                  <img src="@/assets/images/delete.svg"/>
                </div>
              </div>
            </div>
          </div>
          <template v-if="isLoadingUnread">
            <AppLoading/>
          </template>
          <div class="text-center pt-3" v-if="!unreadNotifications.length && !isLoadingUnread">
            新しい通知はありません
          </div>
        </template>
      </div>
    </CusModal>
    <CusModal v-if="isConfirmLogout" :modalId="'modal-confirm-logout-mobile'">
      <div class="modal-confirm-delete">
        <p class="title">{{ $i18n.t('confirm_logout') }}</p>
        <br/>
        <div class="d-flex justify-content-center">
          <button
            class="btn-cancel"
            @click.prevent="confirmLogout"
          >
            {{ $i18n.t('message.modal.cancel') }}
          </button>
          <button class="btn-delete" @click="()=>{ logOut(), onClose() }">
            {{ $i18n.t('message.modal.ok') }}
          </button>
        </div>
      </div>
    </CusModal>
  </div>
</template>

<script>
import router from '@/router';
import { SCREEN_TOP } from '@/constants/screen';
import { NOTI_TABS, FORMAT_DATE_NOTIFICATION } from '@/constants/common';
import CusModal from '@/components/Modals/SubCustomModal.vue';
import { mapGetters } from 'vuex';
import AppLoading from '@/components/Loading/AppLoading.vue';
import { getFcmToken } from '@/utils/token';

export default {
  props: {
    subMenu: Array,
    hasIcon: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AppLoading,
    CusModal,
  },
  data() {
    return {
      NOTI_TABS,
      openModal: false,
      tabName: '',
      currentPageAll: 1,
      currentPageUnread: 1,
      isLoadingAll: false,
      isLoadingUnread: false,
      isConfirmLogout: false,
    };
  },

  computed: {
    ...mapGetters('notification', [
      'allNotifications',
      'unreadNotifications',
      'lastPageAllNotifications',
      'lastPageUnreadNotifications',
      'totalUnread',
    ]),
    ...mapGetters({ isShowNewsIcon: 'news/isShowNewsIcon' }),
  },

  created() {
    this.tabName = NOTI_TABS.TAB_ALL;
  },

  methods: {
    async onClose() {
      this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
    },
    async logOut() {
      const fcmToken = getFcmToken();
      if (fcmToken) await this.$store.dispatch('common/unSubscribeTokenFirebase', fcmToken);
      await this.$store.dispatch('auth/logOut');
      this.$router.push({ name: SCREEN_TOP });
    },
    async getAllNotification() {
      await this.$store.dispatch('notification/getNotificationAll', this.currentPageAll);
      this.isLoadingAll = false;
      if (this.currentPageAll > 1 && this.allNotifications.length) {
        this.handleScrollNotifications();
      }
    },
    async getUnreadNotification() {
      await this.$store.dispatch('notification/getNotificationUnread', this.currentPageUnread);
      this.isLoadingUnread = false;
      if (this.currentPageUnread > 1 && this.unreadNotifications.length) {
        this.handleScrollNotifications();
      }
    },
    handleScrollNotifications() {
      const scroll = document.getElementsByClassName('content-noti')[0];
      scroll.scrollTo(0, scroll.scrollHeight / 2.3);
    },

    formatDate(date) {
      return this.$dayjs(new Date(this.$convertToLocalTime(date))).format(FORMAT_DATE_NOTIFICATION);
    },

    openModalNoti() {
      this.openModal = !this.openModal;
      if (this.openModal) {
        this.isLoadingAll = !this.isLoadingAll;
        this.getAllNotification();
      }
      if (!this.openModal) this.clearNotifications();
    },

    clearNotifications() {
      this.tabName = NOTI_TABS.TAB_ALL;
      this.currentPageAll = 1;
      this.currentPageUnread = 1;
      this.$store.dispatch('notification/clearListNotifications');
    },

    handleLoadMore() {
      const scroll = document.querySelector('.content-noti');
      const isLoad = this.tabName === NOTI_TABS.TAB_ALL ? this.isLoadingAll : this.isLoadingUnread;
      const heightLoadData = Math.round(scroll.offsetHeight * 0.3);
      if (
        scroll.scrollHeight - scroll.scrollTop - heightLoadData < scroll.offsetHeight
        && scroll.scrollTop
        && !isLoad
      ) {
        if (this.tabName === NOTI_TABS.TAB_ALL && !this.isLoadingAll) {
          this.currentPageAll += 1;
          if (this.currentPageAll <= this.lastPageAllNotifications) {
            this.isLoadingAll = true;
            this.getAllNotification();
          }
        } else if (this.tabName === NOTI_TABS.TAB_UNREAD && !this.isLoadingUnread) {
          this.currentPageUnread += 1;
          if (this.currentPageUnread <= this.lastPageUnreadNotifications) {
            this.isLoadingUnread = true;
            this.getUnreadNotification();
          }
        }
        return;
      }
      return;
    },

    changeTab(type) {
      if (this.tabName !== type) {
        this.tabName = type;
        document.querySelector('.content-noti')
          .scrollTo(0, 0);
      }
      if (type === NOTI_TABS.TAB_ALL && !this.allNotifications.length) {
        this.isLoadingAll = !this.isLoadingAll;
        this.getAllNotification();
      }
      if (type === NOTI_TABS.TAB_UNREAD && !this.unreadNotifications.length) {
        this.isLoadingUnread = !this.isLoadingUnread;
        this.getUnreadNotification();
      }
    },

    removeNotification(item, type) {
      const removeData = {
        item,
        type,
      };
      if (type === NOTI_TABS.TAB_ALL) {
        this.allNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = true;
          }
        });
      } else {
        this.unreadNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = true;
          }
        });
      }
      this.$store.dispatch('notification/deleteNotification', item.id);
      setTimeout(() => {
        if (item.is_delete) this.$store.dispatch('notification/clearDeleteNotification', removeData);
      }, 5000);
    },
    undoNotification(item, type) {
      if (type === NOTI_TABS.TAB_ALL) {
        this.allNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = false;
          }
        });
      } else {
        this.unreadNotifications.forEach(el => {
          if (el.id === item.id) {
            item.is_delete = false;
          }
        });
      }
      this.$store.dispatch('notification/undoNotification', item.id);
    },
    directPage(item) {
      if (!item.read_flag) {
        this.$store.dispatch('notification/updateNotification', item.id);
      }
      if (item.redirect_url) {
        this.$router.push(`${item.redirect_url}`);
        this.openModalNoti();
        this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
        this.openModal = false;
      }
    },

    confirmLogout() {
      this.isConfirmLogout = !this.isConfirmLogout;
    },
  },
};
</script>

<style lang="scss">

</style>
